import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "./auth/AuthContext";
import { GardenProvider } from "./context/GardenContext";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
  <React.StrictMode>
      <AuthProvider>
          <GardenProvider>
            <App />
          </GardenProvider>
      </AuthProvider>
  </React.StrictMode>
</BrowserRouter>
);
